import {AES, enc} from 'crypto-js';
import {deleteCookie, getCookie} from 'cookies-next';
import {v7 as uuidv7} from 'uuid';
import {
  AUTH_TOKEN,
  COOKIE_LOGIN_AUTH,
  SECRET,
  OBS_ID,
} from '@jobseeker/common-core/constants';

const storeAuth = (token: string, expires?: number): void => {
  const authMeta = {
    token: AES.encrypt(token, SECRET).toString(),
    expires,
  };

  localStorage.setItem(AUTH_TOKEN, JSON.stringify(authMeta));
};

const storeObsId = (id: string) => {
  localStorage.setItem(OBS_ID, id);
};

const getObsId = () => {
  return localStorage.getItem(OBS_ID);
};

const getAuth = () => {
  const authMeta = localStorage.getItem(AUTH_TOKEN);

  if (authMeta) {
    const parsedAuthMeta: {token: string; expires: number} =
      JSON.parse(authMeta);

    return {
      token: AES.decrypt(parsedAuthMeta['token'], SECRET).toString(enc.Utf8),
      expires: parsedAuthMeta['expires'],
    };
  }
  return {};
};

const clearAuth = (): void => {
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(OBS_ID);
  deleteCookie('filter');
  localStorage.removeItem('filter');
  if (process.env.NEXT_PUBLIC_FILTER_CAT_TAG === 'true' && process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs') {
    deleteCookie('filterCat');
    localStorage.removeItem('filterCat');
  }
};

const checkLoginCookieExist = (): string => {
  const cookie = getCookie(COOKIE_LOGIN_AUTH, {
    domain:
      process.env.NEXT_PUBLIC_TRAIL === 'true'
        ? 'localhost'
        : process.env.NEXT_PUBLIC_DOMAIN,
  });

  if (cookie && typeof cookie === 'string') {
    const parts = cookie.split('.');
    if (parts && parts.length === 3) {
      return cookie;
    }
    return '';
  }
  return '';
};

const isAuthValid = () => {
  const cookie = checkLoginCookieExist();

  if (cookie) {
    return true;
  }
  // For localhost only
  if (process.env.NEXT_PUBLIC_TRAIL === 'true') {
    const {token} = getAuth() || {};
    if (token && typeof token === 'string') {
      return true;
    }
    return false;
  }

  return false;
};

const getMachineId = () => {
  let machineId = localStorage.getItem('MachineId');
  if (!machineId) {
    machineId = uuidv7();
    localStorage.setItem('MachineId', machineId);
  }

  return machineId;
};

export {
  storeAuth,
  getAuth,
  clearAuth,
  checkLoginCookieExist,
  isAuthValid,
  getObsId,
  storeObsId,
  getMachineId,
};
